export enum EventType {
  All = -1,
  Regular = 0,
  Booking = 5,
  BookingV2 = 6,
  Conference = 2,
  Donation = 3,
  DetailedGroupBooking = 7,
  Tickets = 100,
  Membership = 9,
  CourseRepeatingType = 10,
  CourseRepeating = -10,
  Giftcard = 8,
}


export enum EventListViewMode {
  All = -1,
  Booking = 0,
  Events = 0,

}
